// extracted by mini-css-extract-plugin
export default {"header":"MoreDetails_header__GqYTP","title":"MoreDetails_title__7fTw8"};